import defaultMenuStyles from '../default.module.css';

import React, { forwardRef, useEffect, useState } from 'react';
import DropdownComponent from '../../../Widgets/Dropdown/DropdownComponent';
import PopupFormTemplate from '../../SchemeUI/PopupFormTemplate';
import { getAllProtocolGroups, getAllProtocols } from 'services/list.services';
import SwitchWidget from 'components/Widgets/Switch';

const ProtocolSelectMenu = forwardRef(
  (
    {
      protocol,
      position = {
        top: 0 | undefined,
        right: 0 | undefined,
        bottom: 0 | undefined,
        left: 0 | undefined,
      },
      onClose,
      onSelect = undefined,
    },
    menuRef,
  ) => {
    const [selectedGroup, setSelectedGroup] = useState(() => protocol?.id_group ?? '');
    const [selectedProtocol, setSelectedProtocol] = useState(protocol?.id ?? '');
    const [isActive, setIsActive] = useState(protocol?.is_active ?? true);
    const [protocolsOptions, setProtocolsOptions] = useState([protocol]);
    const [protocolGroupsOptions, setProtocolGroupsOptions] = useState([]);

    useEffect(() => {
      loadGroups();
    }, []);

    useEffect(() => {
      selectedGroup && loadProtocols(selectedGroup);
      setSelectedProtocol('');
    }, [selectedGroup]);

    useEffect(() => {
      setIsActive(protocolsOptions.find((item) => item.id === selectedProtocol)?.is_active ?? true);
    }, [selectedProtocol]);

    const loadGroups = async () => {
      const result = await getAllProtocolGroups({ sorting: { field: 'name', type: 'asc' } });
      setProtocolGroupsOptions(result?.data ?? []);
      setSelectedProtocol(protocol?.id ?? '');
    };

    const loadProtocols = async (id) => {
      const result = await getAllProtocols({ sorting: { field: 'name', type: 'asc' } }, id);
      const protocols = result?.data;
      if (protocols && !protocol.is_active && protocol.id_group === id) {
        protocols.push(protocol);
      }
      setProtocolsOptions(protocols ?? []);
    };

    const handleCloseClick = () => {
      if (onClose) onClose();
    };

    const handleSaveClick = () => {
      if (onSelect)
        onSelect(
          selectedProtocol,
          protocolsOptions.find((item) => item.id === selectedProtocol).is_active !== isActive,
        );
    };

    return (
      <PopupFormTemplate
        ref={menuRef}
        position={position}
        disabled={!selectedGroup || !selectedProtocol}
        onSubmit={handleSaveClick}
        onClose={handleCloseClick}
      >
        <div className={defaultMenuStyles.formField}>
          <div className={defaultMenuStyles.label}>Выберите группу:</div>
          <DropdownComponent
            items={protocolGroupsOptions}
            keyItem={'id'}
            valueItem={'name'}
            selectedKey={selectedGroup}
            onChange={(value) => setSelectedGroup(value)}
          />
        </div>
        <div className={defaultMenuStyles.formField}>
          <div className={defaultMenuStyles.label}>Выберите протокол:</div>
          <DropdownComponent
            items={protocolsOptions}
            keyItem={'id'}
            valueItem={'name'}
            selectedKey={selectedProtocol}
            onChange={(value) => {
              setSelectedProtocol(value);
            }}
            disabled={!selectedGroup}
          />
        </div>
        {protocolsOptions.find((item) => item.id === selectedProtocol)?.is_active === false && (
          <div className={defaultMenuStyles.formField}>
            <div className={defaultMenuStyles.switchLabel}>Включить:</div>
            <SwitchWidget selected={isActive} onChange={(val) => setIsActive(val.value)} />
          </div>
        )}
      </PopupFormTemplate>
    );
  },
);

export default ProtocolSelectMenu;
